define('plugin/invoice/collection/UnpaidInvoicesCollection',['require','lib/collection/BaseCollection','plugin/invoice/model/InvoiceModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');

    /**
     * Unpaid invoices collection
     *
     * @class UnpaidInvoicesCollection
     */
    return BaseCollection.extend({

        url: '/ext/invoice/unpaid',
        model: InvoiceModel

    });

});
